import MitHomePage from '../pages/MitHomePage.vue';

import MitMyStoragePage from '../pages/MitMyStoragePage.vue';

import MitStoragePage from '../pages/MitStoragePage.vue';
import MitStorageDetailsPage from '../pages/MitStorageDetailsPage.vue';
import MitExploreStoragePage from '../pages/MitExploreStoragePage.vue';

import MitAdminApiPage from '../pages/MitAdminApiPage.vue'


export const defaultRoute = 'explore-storage';

export function getAppRoutes(MitUserModel, routerGuardAccessCheck) {
    return [
      {
          path: '/home',
          name: 'home',
          component: MitHomePage,
          props: true,
      },
      {
          path: '/my/storage',
          name: 'my-storage',
          component: MitMyStoragePage,
          meta: { allowedRole: MitUserModel.ROLES.USER },
          props: true,
          beforeEnter(to, from, next) { routerGuardAccessCheck(to, from, next) }
      },
      {
          path: '/storage',
          name: 'storage',
          component: MitStoragePage,
          meta: { allowedRole: MitUserModel.ROLES.USER },
          props: true,
          beforeEnter(to, from, next) { routerGuardAccessCheck(to, from, next) }
      },
      {
          path: '/explore/storage*',
          name: 'explore-storage',
          component: MitExploreStoragePage,
          meta: { allowedRole: MitUserModel.ROLES.USER },
          props: true,
          beforeEnter(to, from, next) { routerGuardAccessCheck(to, from, next) }
      },
      {
          path: '/storage/:id',
          name: 'storage-details',
          component: MitStorageDetailsPage,
          meta: { allowedRole: MitUserModel.ROLES.USER },
          props: true,
          beforeEnter(to, from, next) { routerGuardAccessCheck(to, from, next) }
      },
      {
          path: '/admin/api',
          name: 'admin-api',
          component: MitAdminApiPage,
          meta: { allowedRole: MitUserModel.ROLES.ADMIN },
          props: true,
          beforeEnter(to, from, next) { routerGuardAccessCheck(to, from, next) }
      }
    ]
}
